import { VEEVA_CONFIG_COUNTRY_TYPES } from "../../../utils/appList";

const ViewVeevaConfig = ({ data }) => {
    const {
        aemCountryNode,
        aemLanguageNode,
        country,
        countryType,
        identityType,
        identityTypeName,
        salesforceCountryCode,
        veevaInstanceType,
        veevaSpecilityFilter,
    } = data;

    return (
        <>
            <h5 className="mb-4">View Veeva Config</h5>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Country</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{country}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Country Type</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">
                                {(
                                    VEEVA_CONFIG_COUNTRY_TYPES.find(
                                        (item) => item.id === countryType.toString()
                                    ) || {}
                                ).name || ""}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">AEM Country Node</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{aemCountryNode}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">AEM Language Node</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{aemLanguageNode}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Identity Type</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{identityType}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Identity Type Name</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{identityTypeName}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Sales Force Country Code</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{salesforceCountryCode}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Veeva Specility Filter</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{veevaSpecilityFilter}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Veeva Instance Type</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{veevaInstanceType}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewVeevaConfig;
